<template>
  <div v-if="isShow" class="result-group-xd result-xd">
    <img src="/images/dia-xd.png" alt="" class="dia dish-open">
    <div class="result-group-xd-chip" :class="css">
      <img :src="getDiceImage(0)" alt="" class="chip-xd">
      <img :src="getDiceImage(1)" alt="" class="chip-xd">
      <img :src="getDiceImage(2)" alt="" class="chip-xd">
      <img :src="getDiceImage(3)" alt="" class="chip-xd">
    </div>
  </div>
</template>

<script>

export default {
  props: {
    score: { type: Object, default: () => ({})},
    isShow: { type: Boolean, default: false },
  },
  data() {
    return {
      css: 'random1',
    }
  },
  computed: {
    newGame: function() { return this.data.newGame; },
  },
  watch: {
    isShow: function(newVal){
      this.css = this.randomItem(['random1','random2','random3','random4','random5']);
    }
  },
  methods: {
    getDiceImage(pos){
      if(this.score === undefined || this.score.first === undefined) return '/images/dice-red.png';
      let value = '';
      switch(pos) {
        case 0:
          value = this.score.first.value;
          break;
        case 1:
          value = this.score.second.value;
          break;
        case 2:
          value = this.score.third.value;
          break;
        case 3:
          value = this.score.fourth.value;
          break;
      }
      return value === '2' ? '/images/dice-red.png' : '/images/dice-white.png';
    },
    randomItem(items) {
      return items[Math.floor(Math.random()*items.length)];
    }
  }
}
</script>

<style scoped>
.result-xd {
  top: 45px;
  left: 55%;
  width: 60%;
}

/* .dish-open {
  width: 80%;
  margin-left: 7%;
  margin-top: 6%;
} */
</style>